// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FooterSocialFacebook: React.FC<{ size?: number; color1?: string; className?: string }> = ({
    size = 24,
    className,
}) => (
    <svg className={className} focusable="false" viewBox="0 0 24 24" width={size} height={size}>
        <path
            fill="currentColor"
            d="M24 12c0-6.628-5.372-12-12-12S0 5.372 0 12c0 5.625 3.877 10.35 9.103 11.648v-7.982H6.628V12h2.475v-1.58c0-4.082 1.847-5.976 5.86-5.976.759 0 2.071.15 2.61.3v3.319a16 16 0 0 0-1.387-.047c-1.969 0-2.728.745-2.728 2.68V12h3.919l-.675 3.666h-3.249v8.245C19.397 23.194 24 18.136 24 12"
        />
    </svg>
);

export default React.memo(FooterSocialFacebook);
